import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { FormStatusEnum, NotificationType } from 'src/app/common/enumerations/enumerations';
import { MessagePlaceholder } from 'src/app/common/models/placeholder';
import { utils } from 'src/app/modules/libs/utils';
import { WfSignatureResource, WFTaskSignatureResource } from 'src/app/components/workflow/workflow';
import { WorkFlowService } from 'src/app/components/workflow/workflow.service';
import { SCFMaster, SCFAmendment } from '../../scf';
import { SCFPrivileges, ScfV2Service } from '../../scf-v2.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { NotificationService } from 'src/app/components/catalogs/notifications/services/notification.service';
import { CancelDialogComponent } from 'src/app/controls/cancel-dialog/cancel-dialog.component';
import { MessageTypeEnum } from 'src/app/components/messages/services/message-banner.enums';
import { NotificationMessage } from 'src/app/components/catalogs/notifications/services/notification.models';
import { TextareaDialogComponent } from 'src/app/controls/textarea-dialog/textarea-dialog.component';
import { FormViewState } from 'src/app/common/models/form-view-state';


@Component({
  selector: 'scf-v2-main-buttons',
  templateUrl: './scf-v2-main-buttons.component.html',
  styleUrls: ['./scf-v2-main-buttons.component.scss']
})
export class ScfV2MainButtonsComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  @Input() scfMaster?: SCFMaster | null;
  @Input() disabled? = true;
  @Input() privileges?: SCFPrivileges;
  @Input() status?: FormViewState;
  @Input() valid?: boolean;

  @Output() changed = new EventEmitter<SCFMaster>();
  @Output() setSetatus = new EventEmitter<FormViewState>();
  @Output() saved = new EventEmitter<SCFMaster | null>();
  @Output() saveClicked = new EventEmitter();

  disableControls = true;

  scfAmendment?: SCFAmendment;
  scfAmendmentNumber?: number;

  disapproveSignature?: WfSignatureResource;

  constructor(
    private scfService: ScfV2Service,
    public wfService: WorkFlowService,
    private notificationService: NotificationService,
    protected override injector: Injector
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getValues();
    this.setDisabled();
  }

  ngOnInit(): void {

  }

  getValues() {
    if (this.status?.isViewingAmendment) {
      this.scfAmendment = this.scfMaster?.scfAmendments?.find(x => x.active);
      this.scfAmendmentNumber = this.scfMaster?.scfAmendments?.filter(x => x.status != FormStatusEnum.Canceled).length;
    }
    this.disapproveSignature = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals.find(x => x.number == 2)?.wfSignatures?.find(x => x.disapproveID);
  }

  setValues() {

  }

  setDisabled() {
    if (this.disabled) {
      this.disableControls = true;
    }
    else if (this.status?.isCreating || this.status?.isEditing || this.status?.isCreatingAmendment || this.status?.isEditingAmendment) {
      this.disableControls = false;
    }
    else {
      this.disableControls = true;
    }
  }

  async updateNoRefresh() {
    if (this.scfMaster && this.isFormDirty()) {
      this.saveClicked.emit();
      this.alert.success('Update/Save');
      return await this.scfService.put(this.scfMaster, false).toPromise();
    }
    else return null;
  }

  async updateAndRefresh() {
    if (this.scfMaster && this.isFormDirty()) {
      this.saveClicked.emit();
      this.alert.success('Update/Save');
      return await this.scfService.put(this.scfMaster, true).toPromise();
    }
    else return null;
  }

  async save(status: FormStatusEnum) {
    const oldStatus = this.scfMaster?.status;
    if (this.scfMaster) {
      if (this.scfMaster.status === FormStatusEnum.AmendmentDrafting) {
        status = this.scfMaster.status;
      } else {
        this.scfMaster.status = status;
      }
    }

    await this.updateAndRefresh();

    const wfSignature = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 2)?.wfSignatures?.find(x => x.code == 'SUBMIT');
    if (wfSignature && status == FormStatusEnum.WorkApprovals) {
      const wfTaskSignature: WFTaskSignatureResource = {
        taskId: wfSignature.taskID,
        actionId: wfSignature.approveID
      };
      this.sign(wfTaskSignature);
    }
    else if (status == FormStatusEnum.Draft && oldStatus == FormStatusEnum.WorkApprovals) {
      const wfUnsubmitSignature = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 2)?.wfSignatures?.find(x => x.code == 'RWAPI');
      if (wfUnsubmitSignature?.disapproveID) {
        const wfTaskSignature: WFTaskSignatureResource = {
          taskId: wfUnsubmitSignature.taskID,
          actionId: wfUnsubmitSignature.disapproveID
        };
        this.sign(wfTaskSignature);
      }
    }
    this.createNotification();
    this.setFormDirty(false);

  }



  createNotification() {
    if (this.scfMaster?.id)
      this.notificationService.getNotification(NotificationType.CreateSCF, this.scfMaster?.id, this.scfMaster.locations).toPromise().then(async data => {
        if (!data && this.scfMaster?.id) {
          const notification = {
            notificationId: NotificationType.CreateSCF,
            documentId: this.scfMaster?.id,
            toAddresses: this.utils.JSONstringify({ computed: await this.scfService.getEmails(this.scfMaster), added: [] }),
            type: 5,
            locations: this.scfMaster.locations ?? []
          } as NotificationMessage;
          this.notificationService.createNotification(notification).toPromise();
        }
      });
  }

  sign(wfTaskSignature: WFTaskSignatureResource) {
    this.scfService.sign(wfTaskSignature).toPromise().then(() => {
      if (this.scfMaster?.id)
        this.notificationService.getNotification(NotificationType.CreateSCF, this.scfMaster?.id, this.scfMaster.locations).toPromise().then(async notification => {
          this.setFormDirty(false);
          if (this.scfMaster)
            await this.scfService.getEmails(this.scfMaster).then(async scfMails => {
              if (notification != null) {
                const toAddressesAdded = utils.JSONparse(notification.toAddresses)?.added;
                notification.toAddresses = JSON.stringify({ computed: scfMails, added: toAddressesAdded });
                await this.notificationService.saveNotification(notification).toPromise().then(() => { }, () => this.alert.defaultError());
              }
            }).catch(error => {
              this.alert.defaultError();
              console.error(error);
            });
        }).catch(error => {
          this.alert.defaultError();
          console.error(error);
        });
    }).catch(error => {
      this.alert.defaultError();
      console.error(error);
    }).finally(() => {
    });
  }

  isValid() {
    if (!this.status?.isViewingAmendment) {
      return this.valid && this.scfMaster?.scfRestrictionsV2 && this.scfMaster?.scfRestrictionsV2.length !== 0;
    }
    else {
      const scfAmendment = this.scfMaster?.scfAmendments?.find(x => x.active);
      return this.valid && scfAmendment?.scfRestrictionsV2?.length !== 0;
    }
  }

  async submitAmendment() {
    if (this.scfMaster) {
      this.scfMaster.editingById = null;
      this.scfMaster.editingUntil = null;
      const scfMaster = await this.updateNoRefresh();
      const wfSignature = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 5)?.wfSignatures?.find(x => x.code == 'SUBMIT' && x.signedBy == null);
      if (wfSignature) {
        const wfTaskSignature: WFTaskSignatureResource = {
          taskId: wfSignature.taskID,
          actionId: wfSignature.approveID
        };
        this.scfService.sign(wfTaskSignature).toPromise().then(() => {
          this.setFormDirty(false);
          this.alert.message('amendment has been Submitted', [new MessagePlaceholder('{serialNo}', this.scfMaster?.serialNo ?? '')]);
        },
          error => {
            this.alert.defaultError();
          }
        );
      }
    }
  }

  unsubmitAmendment() {
    const wfSignature = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 6)?.wfSignatures?.find(x => x.code == 'RWAPI' && !x.signed);
    if (wfSignature?.disapproveID) {
      const wfTaskSignature: WFTaskSignatureResource = {
        taskId: wfSignature.taskID,
        actionId: wfSignature.disapproveID,
        reason: 'Unsubmitted by ' + this.currentUser?.name
      };
      this.scfService.sign(wfTaskSignature).toPromise().then(() => {
        this.alert.message('amendment has been Unsubmitted', [new MessagePlaceholder('{serialNo}', this.scfMaster?.serialNo ?? '')], MessageTypeEnum.Warning);
      },
        error => {
          this.alert.defaultError();
        }
      );
    }
  }

  cancel() {
    const confirm = this.dialog.open(CancelDialogComponent, {
      width: '600px',
      data: {
      }
    });
    confirm.afterClosed().subscribe(data => {
      if (data?.accept && this.scfMaster) {
        this.scfService.cancel(this.scfMaster, data.text).toPromise().then(() => {
          this.setFormDirty(false);
          this.alert.message('CancelSuccess', [new MessagePlaceholder('{reason}', data.text)]);
          this.saved.emit(null);
        });
      }
    });
  }

  cancelAmendment() {
    let cancelTask = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 5)?.wfSignatures?.find(x => x.cancelEnabled);
    if (!cancelTask) {
      cancelTask = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 6)?.wfSignatures?.find(x => (x.code == 'RP' || x.code == 'RWAPI') && x.amendmentNumber == this.scfAmendmentNumber);
    }
    if (cancelTask) {
      const confirm = this.dialog.open(CancelDialogComponent, {
        width: '600px',
        data: {
          amendment: true
        }
      });
      confirm.afterClosed().toPromise().then(data => {
        if (data?.accept && cancelTask?.taskID && cancelTask?.cancelID) {
          const wfTaskSignature: WFTaskSignatureResource = {
            taskId: cancelTask?.taskID,
            actionId: cancelTask?.cancelID,
            reason: data.text
          };
          this.scfService.sign(wfTaskSignature).toPromise().then(() => {
            this.alert.message('CancelAmendmentSuccess', [new MessagePlaceholder('{reason}', wfTaskSignature.reason)]);
            if (this.status) {
              this.status.isCreatingAmendment = false;
              this.status.isViewingAmendment = false;
              this.status.isEditingAmendment = false;
              this.setSetatus.emit(this.status);
            }
            this.scfService.setEditing(this.scfMaster?.id ?? 0, false).toPromise();
            this.setFormDirty(false);
          },
            error => {
              this.alert.defaultError();
            }
          );
        }
      });
    }
    else {
      this.alert.message('No cancel task found');
    }
  }

  disapprove() {
    const confirm = this.dialog.open(TextareaDialogComponent, {
      width: '400px',
      data: {
        label: this.getMessage('disapprove_message')?.description,
        placeholder: 'Disapproval Reason',
        text: ''
      }
    });
    confirm.afterClosed().subscribe((data) => {
      if (data?.acceptClicked) {
        const wfTaskSignature: WFTaskSignatureResource = {
          taskId: this.disapproveSignature?.taskID,
          actionId: this.disapproveSignature?.disapproveID,
          reason: data.text
        };
        this.scfService.sign(wfTaskSignature).toPromise().then(() => { });
      }
    });
  }


}
